import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import Tag from "../../ui-components/molecules/tag/tag";
import { TagColor } from "../../app/data/common/tagColor";

const columnHelper = createColumnHelper<any>();

const GetTerminalSummaryColumns = (
) => {

  return [
    columnHelper.accessor("terminalNumber", {
      id: "terminalNumber",
      header: "Terminal No",
      enableColumnFilter: false,
      size: 50,
    }),
    columnHelper.accessor("terminalName", {
      id: "terminalName",
      header: "Terminal Name",
      enableColumnFilter: false,
      size: 110,
    }),
    columnHelper.accessor("airportCode", {
      id: "airportCode",
      header: "Airport Code",
      enableColumnFilter: false,
      size: 80,
    }),
    columnHelper.accessor("address.physicalAddress", {
      id: "address.physicalAddress",
      header: "Address",
      enableColumnFilter: false,
      size: 240,
      cell: (cellProps) => (
        <div>{cellProps.getValue()}</div>
      ),
    }),
    columnHelper.accessor("region.regionName", {
      id: "origin.regionName",
      header: "Region",
      enableColumnFilter: false,
      size: 70,
    }),
    columnHelper.accessor("timezone", {
      id: "timezone",
      header: "Timezone",
      enableColumnFilter: false,
      size: 70,
    }),
    columnHelper.accessor("terminalType.type", {
      id: "terminalType.type",
      header: "Type",
      cell: (cellProps) => (
        <Tag mods={{ color: TagColor.GREY, uppercase: true }} mix="xgs-pickup-details__pickup-date__label">
          {cellProps.getValue()}
        </Tag>
      ),
      enableColumnFilter: false,
      size: 120,
    }),
    columnHelper.accessor("contact.managerName", {
      id: "contact.managerName",
      header: "Terminal Manager",
      enableColumnFilter: false,
      size: 120,
    }),
    columnHelper.accessor("contact.phoneNumber", {
      id: "contact.phoneNumber",
      header: "Phone Number",
      enableColumnFilter: false,
      cell: (cellProps) => {
        let cellvalue = cellProps.row.original;
        return (
          <div>{cellvalue?.contact?.phoneNumber !== "0" || null || undefined ? cellvalue?.contact?.phoneNumber.formatPhone() : "N/A"}</div>
        )
      },
      size: 110,
    })
  ]
};

export default GetTerminalSummaryColumns;
